import { createSceneReducer } from 'reducers/reducers-util';
import tutorialsDataReducer from './reducers.data';

export default createSceneReducer(tutorialsDataReducer);
